/**
 * Classe de gestion des stores liés aux fonctionnement du site
 *  */
import { defineStore } from "pinia";

//Store pinia authorizations
export const useSiteOperationalDataStore = defineStore("siteOperationalData", {
  state: () => ({
    currentPage: "" as string,
  }),
  actions: {
    /**
     * Mise à jour du nom de la page dans le fil d'Ariane
     * @param pagelist 
     */
    async setCurrentPage(pagelist: string) {
      this.currentPage = pagelist;
    },
  },
});
